import React, { useState, useEffect } from "react";
import { supabase } from "./supabaseClient";
import Admin from "./Admin";
import Auth from "./Auth";
import OpenRedirect from "./OpenRedirect"; // <-- import your page
import DirectRedirect from "./DirectRedirect"; // <-- import your page
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

export default function App() {
  const [session, setSession] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setSession(session);
      }
    );

    console.log("session", session);
    return () => subscription.unsubscribe();
  }, []);


  const ExternalRedirect = () => {
    useEffect(() => {
          window.location.replace("https://bharatsey.com"); 
    }, []);

    return null; // nothing to render
  };

  return (
    <Router>
      <Routes>
        {/* If not logged in, always redirect to login */}
        {!session ? (
          <>
            <Route path="/login" element={<ExternalRedirect />} />
            <Route path="/login1asda124asf" element={<Auth />} />
            <Route path="/redirect/:id" element={<OpenRedirect />} />
            <Route path="/open/:name/:product_id/:variant_id" element={<DirectRedirect />} />
            {/* <Route path="*" element={<Navigate to="/login" replace />} /> */}
          </>
        ) : (
          <>
            <Route path="/admin" element={<Admin />} />
          </>
        )}
      </Routes>
    </Router>
  );
}
